module.exports = __webpack_public_path__ + "img/apps-store-button-3-x.04d43bf7.png";